export class Covid {
    constructor({ insuranceForm, state }) {
        this.$insuranceForm = insuranceForm;
        this._state = state;

        this.$covidSelect = $(this.$insuranceForm).find('#covid_plus');

        this._selectize = null;

        this._init();
    }

    _init() {
        this._selectize = $(this.$covidSelect).selectize({
            onItemAdd: (value, item) => {
                this._state.covid_plus = value;
            },
        });
    }

    _changeTariff(event) {
        const value = +event.target.value;
        this._selectize[0].selectize.addItem(value);
    }


}